// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__O_PWm"};